import { actionCreatorFactory } from '@core/utils/factories';
import {
  EngineeringBrowse,
  EngineeringDetails,
  EngineeringWorkflowUpdateData,
  PaginatedResponse,
} from '@models/interfaces';

const actionCreator = actionCreatorFactory('ENGINEERING');

export namespace EngineeringActions {
  export const getEngineeringBrowseDataAction =
    actionCreator.createAsyncAction<PaginatedResponse<EngineeringBrowse>>(
      'GET_BROWSE_DATA',
    );
  export const getEngineeringAction =
    actionCreator.createAsyncAction<EngineeringDetails>('GET_ENGINEERING');
  export const updateEngineeringWorkflowAction =
    actionCreator.createAsyncAction<EngineeringWorkflowUpdateData>(
      'UPDATE_ENGINEERING_WORKFLOW',
    );
}
